<app-page-header title="Tenant User Definition" subtitle="Manage tenant-specific user accounts and access">
    <div actions class="flex gap-2">
        <p-iconfield>
            <p-inputicon class="pi pi-search" />
            <input type="text" pInputText placeholder="Search" (input)="onGlobalSearch($event)" />
        </p-iconfield>
        <p-button label="Add New" (click)="openCreate()" icon="pi pi-plus"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        [value]="tenantUsers"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [scrollable]="true"
        scrollHeight="flex"
        dataKey="id"
        [rowHover]="true"
        [globalFilterFields]="['userName', 'tenantName']"
    >
        <ng-template #header>
            <tr>
                <th pSortableColumn="id" class="text-left w-[100px]">
                    <div class="flex items-center gap-2">
                        ID
                        <p-sortIcon field="id"></p-sortIcon>
                    </div>
                </th>
                <th pSortableColumn="userName" class="text-left">
                    <div class="flex items-center gap-2">
                        User Name
                        <p-sortIcon field="userName"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="userName" display="menu"></app-column-filter>
                    </div>
                </th>
                <th pSortableColumn="tenantName" class="text-left">
                    <div class="flex items-center gap-2">
                        Tenant Name
                        <p-sortIcon field="tenantName"></p-sortIcon>
                        <app-column-filter [table]="dt" type="text" field="tenantName" display="menu"></app-column-filter>
                    </div>
                </th>
                <th class="w-[80px]"></th>
            </tr>
        </ng-template>
        <ng-template #body let-row>
            <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.userName }}</td>
                <td>{{ row.tenantName }}</td>
                <td class="text-right">
                    <p-button [text]="true" severity="secondary" icon="pi pi-pencil" (click)="openEdit(row)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog
    [header]="isEditMode ? 'Edit Tenant User' : 'New Tenant User'"
    [(visible)]="dialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '450px' }"
>
    <form [formGroup]="userForm" (ngSubmit)="saveUser()">
        <div class="flex flex-col gap-4">
            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">User Name *</label>
                <input
                    type="text"
                    pInputText
                    placeholder="Enter user name"
                    formControlName="userName"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('userName') }"
                />
                @if (isInvalid('userName')) {
                    <small class="text-red-500" *ngIf="userForm.get('userName')?.errors?.['required']">User name is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Password *</label>
                <input
                    type="password"
                    pInputText
                    placeholder="Enter password"
                    formControlName="password"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('password') }"
                />
                @if (isInvalid('password')) {
                    <small class="text-red-500" *ngIf="userForm.get('password')?.errors?.['required']">Password is required.</small>
                }
            </div>

            <div class="flex flex-col">
                <label class="text-sm font-semibold mb-2">Tenant *</label>
                <p-select
                    [options]="tenantTypes"
                    formControlName="tenantId"
                    optionLabel="text"
                    optionValue="id"
                    placeholder="Select a tenant"
                    [filter]="true"
                    filterBy="text"
                    appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isInvalid('tenantId') }"
                ></p-select>
                @if (isInvalid('tenantId')) {
                    <small class="text-red-500">Tenant is required.</small>
                }
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" variant="outlined" (click)="cancelDialog()"></p-button>
            <p-button [label]="isEditMode ? 'Update' : 'Create'" (click)="saveUser()"></p-button>
        </div>
    </ng-template>
</p-dialog>
